import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  CustomSoftIcon,
  IphoneUkIcon,
  GameUkIcon,
  FlutterIcon,
  HealthcareUkIcon,
  ReactUkIcon,
} from "../../../../app-constants";

const StackItem = [
  {
    icon: CustomSoftIcon,
    title: "Custom Software Development",
    description:
      "Harnessing cutting-edge technologies and frameworks, we craft resilient, scalable, and proficient software solutions. As a bespoke software development company in UK, our comprehensive development process allows us to dissect vital business requirements, laying the groundwork for designing intuitive user interfaces. Our objective is to empower businesses to streamline their ongoing development processes and enhance productivity.",
  },
  {
    icon: IphoneUkIcon,
    title: "Software Consulting Services",
    description:
      "Explore specialized consulting services in custom software development London designed to meet your distinct needs. We delve into the core of your digital goals, advising on optimal technology stacks for your project. Our method includes a thorough analysis of your business needs, and ensuring the highest possible ROR for your development project.",
  },
  {
    icon: GameUkIcon,
    title: "Custom CRM Development",
    description:
      "Ensure your company has the flexibility to make real-time changes to its online presence with a tailored content management system. Our dedicated software development team crafts a versatile CMS for your business. The final product is based on an intuitive interface, customization capabilities, and advanced data security measures.",
  },
  {
    icon: FlutterIcon,
    title: "SaaS Product Development",
    description:
      "Renowned for our bespoke SaaS product development, we guarantee zero compatibility issues, complete ownership, and future-proof highlights. Employing agile methodologies and offering competitive pricing, our highly skilled custom software developers in UK are committed to ensuring your project aligns with your specifications. Proficient in mastering all popular SaaS clouds, we deliver unique outcomes swiftly and securely.",
  },
  {
    icon: HealthcareUkIcon,
    title: "Enterprise Software Development",
    description:
      "Explore our enterprise custom software development services encompassing extensive requirements gathering, meticulous design, and strategic software architecture planning, facilitating the creation of scalable digital solutions. Our team of bespoke software developers in London collaborate with you to enhance your existing business infrastructure, delivering improved customer solutions.",
  },
  {
    icon: ReactUkIcon,
    title: "Cloud Software Development",
    description:
      "Utilizing cutting-edge cloud resources like VMs, Containers, CDN, DBaaS, and beyond, our cloud-based software development services guarantee superior performance, scalability, and reliability for your applications. This approach empowers you to maximize the benefits of advanced cloud capabilities, facilitating optimal functionality for your software products.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>Our Advanced Custom Software Services in UK</h2>
            <p className="impro_para">
              TekRevol is known as a credible firm for its custom software
              development UK and we are continuously evolving our services to
              gain the best outcome. Utilizing the latest tech stack and optimal
              approach, we build a robust product that can create a difference
              for your business. You can avail of our diverse custom software
              development solutions according to your business needs.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
